<div class="container-fluid mt-4">
  <div class="card">
    <div class="card-header">
      <h3 class="mb-0">TikTok Ad Batches</h3>
    </div>

    <div class="card-body">
      <!-- Filters -->
      <div class="row mb-4">
        <div class="col-md-4">
          <label class="form-label">Select TikTok Merchant</label>
          <ng-select
            [(ngModel)]="selectedMerchantId"
            (change)="onMerchantChange()"
            [items]="tiktokMerchants"
            bindLabel="name"
            bindValue="merchantId"
            placeholder="Search merchant by name..."
            [loading]="merchantsLoading"
            [clearable]="true"
            [searchable]="true">
          </ng-select>
          <small class="form-text text-muted mt-1" *ngIf="tiktokMerchants.length === 0 && !merchantsLoading">
            No TikTok merchants found. Please configure TikTok credentials in merchant settings.
          </small>
        </div>

        <div class="col-md-4">
          <label class="form-label">Status</label>
          <div>
            <button class="btn btn-sm me-2"
                    [class.btn-primary]="isActiveFilter === null"
                    [class.btn-outline-primary]="isActiveFilter !== null"
                    (click)="toggleActiveFilter(null)">
              All
            </button>
            <button class="btn btn-sm me-2"
                    [class.btn-success]="isActiveFilter === true"
                    [class.btn-outline-success]="isActiveFilter !== true"
                    (click)="toggleActiveFilter(true)">
              Active
            </button>
            <button class="btn btn-sm"
                    [class.btn-danger]="isActiveFilter === false"
                    [class.btn-outline-danger]="isActiveFilter !== false"
                    (click)="toggleActiveFilter(false)">
              Inactive
            </button>
          </div>
        </div>
      </div>

      <!-- Loading State -->
      <div *ngIf="isLoading" class="alert alert-info">
        <span class="spinner-border spinner-border-sm me-2"></span>
        Loading batches...
      </div>

      <!-- Empty State -->
      <div *ngIf="!isLoading && selectedMerchantId && batches.length === 0" class="alert alert-warning">
        No batches found for the selected merchant.
      </div>

      <!-- Batch List Table -->
      <div class="table-responsive" *ngIf="!isLoading && batches.length > 0">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Merchant</th>
              <th>Status</th>
              <th>Products</th>
              <th>Created</th>
              <th>Next Retry</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let batch of batches">
              <td>{{ batch.merchantName }}</td>
              <td>
                <span class="badge"
                      [ngClass]="'bg-' + getStatusColor(batch.displayStatus)">
                  {{ batch.displayStatus }}
                </span>
              </td>
              <td>{{ batch.totalProducts }} products, {{ batch.totalSkus }} SKUs</td>
              <td>{{ batch.createdTime | date:'short' }}</td>
              <td>
                <span *ngIf="batch.status === 'Failed' && batch.nextRetryTime">
                  {{ batch.nextRetryTime | date:'short' }}
                </span>
                <span *ngIf="batch.status === 'Created'">-</span>
              </td>
              <td>
                <button class="btn btn-sm btn-info" (click)="viewBatchDetail(batch.id)">
                  View Details
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <nav aria-label="Page navigation" *ngIf="!isLoading && batches.length > 0">
        <ul class="pagination">
          <li class="page-item" [class.disabled]="currentPage === 1">
            <a class="page-link" (click)="previousPage()" href="javascript:void(0);">Previous</a>
          </li>
          <li class="page-item active">
            <span class="page-link">Page {{ currentPage }}</span>
          </li>
          <li class="page-item" [class.disabled]="(currentPage * pageSize) >= totalBatches">
            <a class="page-link" (click)="nextPage()" href="javascript:void(0);">Next</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>
